var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiamondNewImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2239_2)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M13.3266 0.548437C12.5953 -0.182813 11.4094 -0.182813 10.6734 0.548437L0.548437 10.6734C-0.182813 11.4047 -0.182813 12.5906 0.548437 13.3266L10.6734 23.4516C11.4047 24.1828 12.5906 24.1828 13.3266 23.4516L23.4516 13.3266C24.1828 12.5953 24.1828 11.4094 23.4516 10.6734L13.3266 0.548437Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2239_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamondNewImage);
export default __webpack_public_path__ + "static/media/diamond-new-image.7d3c0c2a8e085e2a215936eeda1ac8c9.svg";
export { ForwardRef as ReactComponent };